import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import { GOOGLE_DEFAULT_PROMPT } from '../types';
import { googleAiVoiceStyles } from '../GoogleAiVoiceStyle';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface GoogleAiVoiceHeaderProps {
  multiSpeaker: boolean;
  prompt: string;
  promptSpeakerA: string;
  promptSpeakerB: string;
  onPromptChange: (value: string) => void;
  onPromptSpeakerAChange: (value: string) => void;
  onPromptSpeakerBChange: (value: string) => void;
}

export default function GoogleAiVoiceHeader({ multiSpeaker, prompt, promptSpeakerA, promptSpeakerB, onPromptChange, onPromptSpeakerAChange, onPromptSpeakerBChange }: GoogleAiVoiceHeaderProps) {
  const theme = useTheme();

  const renderPromptInput = (label: string, value: string, onChange: (value: string) => void) => (
    <Box sx={googleAiVoiceStyles.promptContainerSx(theme)}>
      <TextField
        label={label}
        placeholder={GOOGLE_DEFAULT_PROMPT}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        size='small'
        variant='outlined'
        fullWidth
        sx={googleAiVoiceStyles.promptTextFieldSx(theme)}
        InputProps={{ endAdornment: <AutoAwesomeIcon /> }}
      />
    </Box>
  );

  return (
    <div style={googleAiVoiceStyles.headerRow(theme)}>
      <div style={{ display: 'flex', flexDirection: 'row', gap: theme.spacing(1), flex: '1 1 auto', paddingRight: theme.spacing(1.5)}}>
        {!multiSpeaker ? (
          renderPromptInput('Prompt', prompt, onPromptChange)
        ) : (
          <>
            {renderPromptInput('Voice #1 prompt', promptSpeakerA, onPromptSpeakerAChange)}
            {renderPromptInput('Voice #2 prompt', promptSpeakerB, onPromptSpeakerBChange)}
            {renderPromptInput('Global prompt', prompt, onPromptChange)}
          </>
        )}
      </div>
      <div style={{ flexBasis: '360px', minWidth: '320px' }}></div>
    </div>
  );
}
